import React from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';

export default function ProspectingIcpBanner({ icp, onBuildList, savingList }) {
  if (!icp) return null;

  return (
    <div className="border-b border-brand-100 bg-gradient-to-r from-brand-50 to-white px-6 py-4 dark:border-brand-900/50 dark:from-brand-950/30 dark:to-gray-900">
      <div className="flex items-start gap-4">
        <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl bg-white text-brand-600 shadow-sm ring-1 ring-brand-100 dark:bg-gray-900 dark:text-brand-300 dark:ring-brand-900">
          <Sparkles className="h-5 w-5" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="text-[10px] font-semibold uppercase tracking-wider text-brand-700 dark:text-brand-300">
            Searching for
          </div>
          <div className="mt-1 text-sm font-semibold leading-5 text-gray-950 dark:text-white">
            {icp.headline}
          </div>
          <div className="mt-2 flex flex-wrap gap-1.5">
            {(icp.facets || []).slice(0, 5).map((facet) => (
              <span
                key={facet.key || facet.label}
                className="inline-flex max-w-full items-center rounded-full border border-brand-200 bg-white px-2.5 py-1 text-[11px] font-medium text-brand-800 dark:border-brand-800 dark:bg-gray-900 dark:text-brand-200"
              >
                <span className="text-brand-500 dark:text-brand-400">{facet.label.toLowerCase()}:</span>
                <span className="ml-1 truncate">{facet.value}</span>
              </span>
            ))}
          </div>
        </div>
        {onBuildList && (
          <button
            type="button"
            onClick={onBuildList}
            disabled={savingList}
            className="inline-flex flex-shrink-0 items-center gap-1.5 rounded-lg bg-brand-600 px-3 py-2 text-xs font-semibold text-white transition-colors hover:bg-brand-700 disabled:cursor-not-allowed disabled:opacity-60"
          >
            {savingList ? 'Building list' : 'Open table view'}
            <ArrowRight className="h-3.5 w-3.5" />
          </button>
        )}
      </div>
    </div>
  );
}
